import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isChapterModalOpen: false,
  isEditChapterModalOpen: false,
  isTopicModalOpen: false,
  isTopicEditModalOpen: false,
  chapterId: null,
  isChangePassword: false,
  // exams states
  eSubjectTopicModal: false,
  eSubjectSubTaskModal: false,
  eSubjectConceptModal: false
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openCreateChapterModal: (state, action) => {
      state.isChapterModalOpen = action.payload
    },
    closeCreateChapterModal: (state, action) => {
      state.isChapterModalOpen = action.payload;
    },
    openEditChapterModal: (state, action) => {
      state.isEditChapterModalOpen = action.payload;
    },
    closeEditChapterModal: (state, action) => {
      state.isEditChapterModalOpen = action.payload;
    },
    openTopicCreateModal: (state, action) => {
      state.isTopicModalOpen = action.payload;
    },
    closeTopicCreateModal: (state, action) => {
      state.isTopicModalOpen = action.payload
    },
    openTopicEditModal: (state, action) => {
      state.isTopicEditModalOpen = action.payload;
    },
    closeTopicEditModal: (state, action) => {
      state.isTopicEditModalOpen = action.payload
    },
    openChangePasswordModal: (state, action) => {
      state.isChangePassword = action.payload
    },
    closeChangePasswordModal: (state, action) => {
      state.isChangePassword = action.payload
    },
    openESubjectTopicModal: (state, action) => {
      state.eSubjectTopicModal = true
    },
    closeESubjectTopicModal: (state, action) => {
      state.eSubjectTopicModal = false
    },
    openESubjectSubTaskModal: (state, action) => {
      state.eSubjectSubTaskModal = true
    },
    closeESubjectSubTaskModal: (state, action) => {
      state.eSubjectSubTaskModal = false
    },
    openEsubjectConceptModal: (state, action) => {
      state.eSubjectConceptModal = true
    },
    closeEsubjectConceptModal: (state, action) => {
      state.eSubjectConceptModal = false
    }
  },
})

// Action creators are generated for each case reducer function
export const { openCreateChapterModal, closeCreateChapterModal, openEditChapterModal, closeEditChapterModal, openTopicCreateModal, closeTopicCreateModal, openTopicEditModal, closeTopicEditModal,

  openChangePasswordModal, closeChangePasswordModal,
  openESubjectTopicModal,
  closeESubjectTopicModal,
  openESubjectSubTaskModal,
  closeESubjectSubTaskModal,
  openEsubjectConceptModal,
  closeEsubjectConceptModal
} = modalSlice.actions

export default modalSlice.reducer;